export const OrderTypes = {
  ASC: 1,
  DESC: 2,
};

export const OrderTypeName = {
  [OrderTypes.ASC]: 'ascending',
  [OrderTypes.DESC]: 'descending',
};

export const SortingPropNames = {
  FIELD: 'fieldType',
  TYPE: 'orderType',
};
